<template>
  <div class="page">
    <el-tabs class="tabsdiv" @tab-click="handleClick" v-model="activeName" type="border-card">
      <el-tab-pane class="gaojiandiv" name="1" label="投稿列表">
        <el-table :data="activeTabData" style="width: 100%;min-height: 600px;">
          <el-table-column show-overflow-tooltip prop="title" label="稿件标题">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="author" label="稿件作者">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="summary" label="稿件摘要">
          </el-table-column>
          <el-table-column prop="categoryId" show-overflow-tooltip width="90" label="稿件类目">
            <template slot-scope="scope">
              <div>{{scope.row.categoryName}},{{categoryCustom(scope.row.categoryCustom)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="90" prop="status" label="稿件状态">
            <template slot-scope="scope">
              <div style="color: red;font-weight: bold;" v-if="scope.row.status=='1'">已锁定</div>
              <div style="color: rgb(99, 149, 240);font-weight: bold;" v-else>未锁定</div>
            </template>
          </el-table-column>
          <el-table-column width="170" align="center" prop="createTime" label="创建时间">
            <template slot-scope="scope">{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
          </el-table-column>
          <el-table-column align="center" width="190" label="操作">
            <template slot-scope="scope">
              <!-- <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
                <el-button @click="infoClick(scope.$index, scope.row)" size="small" type="primary" icon="el-icon-camera" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                <el-button @click="editClick(scope.$index, scope.row)" size="small" type="primary" icon="el-icon-edit" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="分享" placement="top-start">
                <el-button @click="shareClick(scope.$index, scope.row)" size="small" type="success" icon="el-icon-share" circle></el-button>  
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                <el-button @click="deleteClick(scope.$index, scope.row)" size="small" type="danger" icon="el-icon-delete" circle></el-button>
              </el-tooltip> -->
              <el-button @click="infoClick(scope.$index, scope.row,'active')" size="small" type="primary"
                icon="el-icon-view" circle></el-button>
              <el-button @click="editClick(scope.$index, scope.row)" size="small" type="primary" icon="el-icon-edit"
                circle></el-button>
              <el-button @click="shareClick(scope.$index, scope.row)" size="small" type="success" icon="el-icon-share"
                circle></el-button>
              <el-button @click="deleteClick(scope.$index, scope.row)" size="small" type="danger" icon="el-icon-delete"
                circle></el-button>
              <!-- <el-button size="mini" type="primary"
                @click="infoClick(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini" type="primary"
                @click="editClick(scope.$index, scope.row)">修改</el-button>
              <el-button size="mini" type="primary"
                @click="editClick(scope.$index, scope.row)">分享</el-button>
              <el-button size="mini" type="danger"
                @click="deleteClick(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination class="pagefy" :total="total" :current-page="pageNumber" :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50]" @current-change="handleCurrentChange" @size-change="handleSizeChange"
            background layout="total, sizes, prev, pager, next"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane class="gaojiandiv" name="2" label="收稿列表">
        <el-table :data="passiveTabData" style="width: 100%;min-height: 600px;">
          <el-table-column show-overflow-tooltip prop="title" label="稿件标题">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="author" label="稿件作者">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="summary" label="稿件摘要">
          </el-table-column>
          <el-table-column prop="categoryId" show-overflow-tooltip width="90" label="稿件类目">
            <template slot-scope="scope">
              <div>{{scope.row.categoryName}},{{categoryCustom(scope.row.categoryCustom)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="90" prop="status" label="稿件状态">
            <template slot-scope="scope">
              <div style="color: red;font-weight: bold;" v-if="scope.row.status=='1'">已锁定</div>
              <div style="color: rgb(99, 149, 240);font-weight: bold;" v-else>未锁定</div>
            </template>
          </el-table-column>
          <el-table-column width="170" align="center" prop="createTime" label="创建时间">
            <template slot-scope="scope">{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
          </el-table-column>
          <el-table-column align="center" width="60" label="操作">
            <template slot-scope="scope">
              <el-button @click="infoClick(scope.$index, scope.row,'passive')" size="small" type="primary"
                icon="el-icon-view" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        activeName: '1',//1是手机号修改密码，2是邮箱修改密码
        activeTabData: [],//active  所投列表
        passiveTabData: [],//passive  被投列表
        total: 0,
        pageNumber: 1,
        pageSize: 10,
      }
    },
    created() {
      this.getActiveTabData();
    },
    //计算属性
    filters: {
    },
    methods: {
      categoryCustom(val) {
        return JSON.parse(val).join(',');
      },
      handleClick(tab, event) {
        if (this.activeName == '1') {
          this.getActiveTabData();
        }
        if (this.activeName == '2') {
          this.getPassiveTabData();
        }
      },
      //所投列表
      getActiveTabData() {
        this.$showLoading();
        axios.get(this.baseUrl.hbjx + '/contribution/queryPage', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            type: 'active',//(passive 被投列表  active  所投列表)
            userId: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
            pageNum: this.pageNumber,
            pageSize: this.pageSize,
          }
        })
          .then((res) => {
            this.total = res.data.total;
            this.activeTabData = res.data.list;
            this.$closeLoading();
          })
          .catch(function (err) {
            console.log(err);
            this.$closeLoading();
          });
      },
      //被投列表
      getPassiveTabData() {
        this.$showLoading();
        axios.get(this.baseUrl.hbjx + '/contribution/queryPage', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            type: 'passive',//(passive 被投列表  active  所投列表)
            userId: JSON.parse(this.baseUrl.getCookie("userInfo")).id,
            pageNum: this.pageNumber,
            pageSize: this.pageSize,
          }
        })
          .then((res) => {
            this.total = res.data.total;
            this.passiveTabData = res.data.list;
            this.$closeLoading();
          })
          .catch(function (err) {
            console.log(err);
            this.$closeLoading();
          });
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getTabData();
      },
      handleCurrentChange(val) {
        this.pageNumber = val;
        this.getTabData();
      },
      //稿件查看
      infoClick(index, row, type) {
        this.$router.push({
          path: '/pageInfo',
          query: {
            manuscriptId: row.id,
            pageType: type
          }
        })
      },
      //稿件编辑
      editClick(index, row) {
        if (row.status == '1') {
          this.$Message.error('稿件已被锁定，无法被修改！');
        } else {
          this.$router.push({
            path: '/editpage',
            query: {
              manuscriptId: row.id
            }
          })
        }
      },
      //删除稿件
      deleteClick(index, row) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: 'true'
        })
          .then(() => {
            let params = new FormData(); // 创建form对象
            params.append("id", row.id); //稿件id
            axios.post(this.baseUrl.hbjx + "/contribution/delTByPrimaryKey", params).then((res) => {
              if (res.data == "success") {
                this.getActiveTabData();
                this.$Message.success('删除成功！');
              }
            });
          })
          .catch(() => { });
      },
      //分享稿件
      shareClick(index, row) {
        this.$router.push({
          path: '/createpagesuccess',
          query: {
            manuscriptId: row.id,
            manuscriptTitle: row.title
          }
        })
      },
    }
  }
</script>
<style scoped>
  /deep/ .el-tabs__item {
    width: 550px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }

  /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom: 1px solid #e0e0e0;
  }

  .tabsdiv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .gaojiandiv {
    min-height: 640px;
  }

  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 750px;
    margin: 5px 0px 0px 0px;
  }

  .pagefy {
    margin-top: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ManuscriptListPage.vue